import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "Início", to: "/" },
  { label: "Loja", to: "/loja" },
  { label: "Vestidos", to: "/loja?cat=Vestidos" },
  { label: "Blazers", to: "/loja?cat=Blazers" },
  { label: "Plus Size", to: "/loja?cat=Moda Plus Size" },
  { label: "Promoções", to: "/loja?tag=promocao" },
];

export const Header = () => {
  const { count, setOpen } = useCart();
  const { user, logout } = useAuth();
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 h-[68px] flex items-center justify-between">
        <button className="md:hidden text-white" onClick={() => setMenu(!menu)} data-testid="mobile-menu-toggle">
          {menu ? <X size={22} /> : <Menu size={22} />}
        </button>

        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <span className="font-bodoni text-2xl md:text-3xl text-rose tracking-tighter group-hover:text-rose-hover transition-colors duration-300">DN</span>
          <span className="hidden sm:flex flex-col leading-none border-l border-white/15 pl-3">
            <span className="font-serif-display text-xl md:text-[24px] tracking-[0.15em] text-white">DONNA NARA</span>
            <span className="label-caps text-rose text-[8px] mt-0.5 tracking-[0.35em]">Moda Feminina</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <Link key={n.label} to={n.to} data-testid={`nav-${n.label}`}
              className="text-[13px] tracking-wide text-white/70 hover:text-rose transition-colors duration-300">
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4 md:gap-5">
          {user ? (
            <button onClick={logout} data-testid="logout-button" title={user.name}
              className="hidden sm:flex items-center gap-2 text-white/70 hover:text-rose transition-colors duration-300">
              <User size={18} /><span className="text-[12px]">Sair</span>
            </button>
          ) : (
            <button onClick={() => navigate("/entrar")} data-testid="header-login-button"
              className="text-white/70 hover:text-rose transition-colors duration-300"><User size={18} /></button>
          )}
          <button onClick={() => setOpen(true)} data-testid="cart-button" className="relative text-white hover:text-rose transition-colors duration-300">
            <ShoppingBag size={20} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-2 bg-rose text-ink text-[10px] font-bold w-4 h-4 flex items-center justify-center">{count}</span>
            )}
          </button>
        </div>
      </div>

      {menu && (
        <div className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl px-5 py-4 flex flex-col gap-4">
          {NAV.map((n) => (
            <Link key={n.label} to={n.to} onClick={() => setMenu(false)}
              className="text-sm text-white/80 hover:text-rose">{n.label}</Link>
          ))}
        </div>
      )}
    </header>
  );
};
